import axios from 'axios';

export const getStats = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}stats`); 
    return response.data;
  } catch (error) {
    console.error('Error fetching stats:', error);
    throw error;
  }
};
